// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__32lhk","list":"BalanceDue_list__1vvRL","listRow":"BalanceDue_listRow__1cxc8","total":"BalanceDue_total__1XLy8"};